import * as React from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { useFlag } from 'toggled'

import { FilterButton, FiltersMobileModal } from '~/components/filters'
import { SortSelect } from '~/components/filters/components/sort-select'
import { PageTitleWithTotal } from '~/components/page-title-with-total'
import { useFiltersState } from '~/hooks/use-filters-state'
import Icon from '~/truck/icon'
import { flags } from '~/utils/constants'

export interface HeaderMobileProps {
  title: string
  numOfHints: number
}

const StyledTitleContainer = styled.div`
  align-items: center;
  display: flex;
  padding: ${props => props.theme.spacing.comfortable}px;
  width: 100%;

  > svg:first-child {
    margin-right: ${props => props.theme.spacing.cozy}px;
  }
`

const StyledFiltersContainer = styled(StyledTitleContainer)`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing.cozy * 1.5}px;
  padding-top: 0px;
`

export function HeaderMobile(props: HeaderMobileProps) {
  const { numOfHints, title } = props

  const router = useRouter()

  const { noFiltersAvailable } = useFiltersState()

  const [isFilterModalOpen, setIsFilterModalOpen] = React.useState(false)

  const hasProductSortingFF = useFlag(flags.PRODUCT_SORTING)

  const onFilterModalOpen = () => setIsFilterModalOpen(true)

  const onFilterModalClose = () => setIsFilterModalOpen(false)

  return (
    <>
      <StyledTitleContainer>
        <Icon type="arrow-left" color="black" onClick={() => router.back()} />
        <PageTitleWithTotal title={title} total={numOfHints} />
      </StyledTitleContainer>
      {!noFiltersAvailable && (
        <StyledFiltersContainer>
          {hasProductSortingFF && <SortSelect />}
          <FilterButton onClick={onFilterModalOpen} />
        </StyledFiltersContainer>
      )}
      {!noFiltersAvailable && isFilterModalOpen && <FiltersMobileModal onClose={onFilterModalClose} />}
    </>
  )
}
